import React from "react";
import coupleImg1 from "../../images/couple/image-1.jpg";
import coupleImg2 from "../../images/couple/image-2.jpg";
import coupleImg3 from "../../images/couple/image-3.jpg";

const CoupleSection: React.FC = () => {
  return (
    <section className="wpo-couple-section">
      <div className="container">
        <div className="row">
          {/* Bride */}
          <div className="col col-lg-3 col-md-12 col-12">
            <div
              className="couple-items wow fadeInLeftSlow"
              data-wow-duration="1400ms"
            >
              <div className="couple-image">
                <img src={coupleImg1} alt="Ella" />
              </div>
              <div className="couple-text">
                <h2>Ella</h2>
                <p>
                  Hoy, me caso con mi mejor amigo. Con alegria en mi corazón y amor 
                  en mis ojos, estoy lista para siempre.
                </p>
              </div>
            </div>
          </div>

          {/* Center Photo */}
          <div className="col col-lg-6 col-md-12 col-12">
            <div
              className="couple-middle-pic wow zoomIn"
              data-wow-duration="1700ms"
            >
              <div className="couple-image">
                <img src={coupleImg2} alt="Pareja" />
              </div>
            </div>
          </div>

          {/* Groom */}
          <div className="col col-lg-3 col-md-12 col-12">
            <div
              className="couple-items wow fadeInRightSlow"
              data-wow-duration="1400ms"
            >
              <div className="couple-image">
                <img src={coupleImg3} alt="El" />
              </div>
              <div className="couple-text">
                <h2>Él</h2>
                <p>
                  Un corazón lleno de amor y un alma llena de esperanza, no puedo esperar para 
                  empezar este viaje contigo a mi lado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoupleSection;
